// extracted by mini-css-extract-plugin
module.exports = {"item-component":"BusinessDetailSections_item-component__1x6GH","section":"BusinessDetailSections_section__2-bTc","fieldLabel":"BusinessDetailSections_fieldLabel__3YWgG"};